export default {"src":"/_next/static/media/mainLogo.067e9339.svg","height":216,"width":720};